export const defaultScrollerConfig = {
    sideSpacing: 10,
    grid: 1355,
    responsive: {
        1275: {
            sideSpacing: 20
        }
    }
}

export const scrollersPredefinedConfigs = {
    product_card_template_specification: {
        itemWidth: 215,
        mode: "off",
        $prevBtn: '<button class="ci-scroller-move-left icube-icon-chevron-left left-tsm-f0 ml-10 sm:ml-0" type="button"></button>',
        $nextBtn: '<button class="ci-scroller-move-right icube-icon-chevron-right right-tsm-f0 mr-10 sm:mr-0" type="button"></button>',
        "$viewport": "scroller"
    }
}